var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcAlertWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gnagof3q2a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9b9b9b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2389",
    transform: "translate(-923 -457)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Ellipse 92",
    d: "M48.5 5a43.513 43.513 0 0 0-16.931 83.584A43.513 43.513 0 0 0 65.431 8.416 43.223 43.223 0 0 0 48.5 5m0-5A48.5 48.5 0 1 1 0 48.5 48.5 48.5 0 0 1 48.5 0z",
    transform: "translate(923 457)",
    style: {
      fill: "url(#gnagof3q2a)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 513",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(968 477)",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3786",
    d: "M-21677.5-2106.44v37.323",
    transform: "translate(22649 2602.346)",
    style: {
      fill: "none",
      stroke: "#707070",
      strokeLinecap: "round",
      strokeWidth: 6
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcAlertWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-alertWarning.dfee16ee3fc38e83e14c7536fe36443e.svg";